import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import NoOrgState from '../pages/NoOrgState';

const ProtectedRoute = ({ children, requiredRoles = [], requiredPermissions = [] }) => {
  const { isAuthenticated, user, permissions, loading } = useAuth();

  if (loading) return <div className="p-8">Loading...</div>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  const hasPlatformRole = (user?.roles || []).includes('Superadmin');

  if (requiredRoles && requiredRoles.length) {
    const userRoles = user?.roles || [];
    const has = requiredRoles.some(r => userRoles.includes(r));
    if (!has) {
      if (!user?.tenant_id) return <NoOrgState />;
      return <Navigate to="/" replace />;
    }
    return children;
  }

  if (!user?.tenant_id && !hasPlatformRole) return <NoOrgState />;

  if (requiredPermissions && requiredPermissions.length) {
    const userPerms = permissions || [];
    const has = requiredPermissions.every(p => userPerms.includes(p));
    if (!has) {
      if (!user?.tenant_id && !hasPlatformRole) return <NoOrgState />;
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
